// removed by extract-text-webpack-plugin
module.exports = {"color-palette":"color-palette","palette-page-control":"palette-page-control","disabled":"disabled","palette-page-control-up":"palette-page-control-up","palette-page-control-down":"palette-page-control-down","palette-grid":"palette-grid","grid-item-container":"grid-item-container","grid-item":"grid-item","palette-item":"palette-item","selected":"selected","used":"used","icon-selected":"icon-selected"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-edit-modal/component/color-palette/color-palette.style.sass
// module id = MkRY
// module chunks = 0